import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useAccountBalanceList = ({ search, page, pageSize }) => {
  const filter = {
    // filter: { noFilter: search },
    paging: { pageIndex: page },
  };

  return useQuery({
    queryKey: ["accountBalanceListState", filter],
    // enabled: true,
    queryFn: async () =>
      callApi({
        path: "openledgers",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
